<template>
  <div>
    <v-row>
      <v-col md="9" cols="12">
        <v-card elevation="2" rounded="xl">
          <v-card-text>
            <v-form ref="formPresentacion">
              <v-row class="mt-0" :no-gutters="$vuetify.breakpoint.mdAndDown">
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    @change="changeOrdenCompra()"
                    label="Tipo"
                    v-model="tipoOrden"
                    :rules="rules.Requerido"
                    :items="types"
                    item-text="name"
                    item-value="id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="6" cols="12">
                  <v-autocomplete
                    v-if="tipoOrden == 'O'"
                    outlined
                    dense
                    @change="changeOrdenCompra()"
                    label="Orden de compra"
                    v-model="Compra.ocm"
                    :rules="rules.Requerido"
                    :items="OrdenesCompra"
                    item-text="Nombre"
                    item-value="id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    label="Departamento"
                    ref="dptField"
                    v-model="Compra.dpt"
                    :rules="rules.Requerido"
                    :items="modulos"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    :disabled="!editableAmc"
                    label="Almacén"
                    v-model="Compra.amc"
                    :rules="rules.Requerido"
                    :items="origenes"
                    item-text="Nombre"
                    item-value="id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    outlined
                    dense
                    label="Descripción"
                    v-model="Compra.dsc"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="3" cols="12" :disabled="Compra.sts != 'P'">
                  <v-textarea
                    outlined
                    dense
                    label="Notas de la compra"
                    v-model="notasProds"
                    rows="1"
                    hide-details
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" cols="12">
        <v-card
          v-if="Compra.sts != 'A' && Compra.sts != 'C'"
          :disabled="!Compra.dpt || !Compra.amc"
          elevation="2"
          rounded="xl"
          class="d-flex align-center"
          height="100%"
        >
          <v-card-text>
            <v-btn v-if="false" @click="$emit('toggle', false)" class="px-1">
              Cerrar
            </v-btn>
            <v-btn
              v-if="edit && Compra.sts != 'A' && Compra.sts != 'C'"
              block
              color="orange"
              dark
              @click="aplicarCompra()"
            >
              Aplicar
            </v-btn>
            <v-btn
              v-if="Compra.sts != 'A' && Compra.sts != 'C'"
              color="green"
              class="mt-1"
              block
              dark
              @click="saveOrdenCompra()"
            >
              Guardar Compra
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-expand-transition>
      <v-alert
        v-show="!Compra.dpt || !Compra.amc"
        type="warning"
        border="left"
        class="mt-2"
        prominent
        outlined
      >
        Selecciona un <strong> Departamento </strong> y un
        <strong> Almacén </strong> para continuar con la compra
      </v-alert>
    </v-expand-transition>

    <v-expand-transition>
      <v-card
        v-show="
          Compra.sts != 'A' && Compra.sts != 'C' && Compra.dpt && Compra.amc
        "
        class="mt-2"
        elevation="2"
        rounded="xl"
      >
        <v-card-text>
          <v-form :key="toAddForm" ref="formProdAdd">
            <v-row class="mt-0" :no-gutters="$vuetify.breakpoint.mdAndDown">
              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  label="Producto"
                  :rules="rules.Requerido"
                  v-model="prodSelected"
                  :items="global_prod"
                  item-text="Nombre"
                  item-value="id"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  label="Presentacion de producto"
                  :rules="rules.Requerido"
                  v-model="reqToAdd.prs"
                  :items="presentacionesBySelectedProd"
                  item-text="title"
                  item-value="Id"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6" md="3" class="px-1 px-md-3">
                <v-text-field
                  outlined
                  dense
                  v-model="reqToAdd.cnt"
                  :rules="rules.Requerido"
                  @keypress="$pgsHelper.onlyNumber($event, reqToAdd.cnt)"
                  :label="'Cantidad'"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6" md="3" class="px-1 px-md-3">
                <v-text-field
                  outlined
                  dense
                  v-model="reqToAdd.pcu.C"
                  :label="'Precio Unitario'"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  outlined
                  dense
                  v-model="reqToAdd.pcu.M"
                  :rules="rules.Requerido"
                  label="Tipo de moneda"
                  item-value="id"
                  item-text="Nombre"
                  :items="monedas"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  block
                  color="green"
                  outlined
                  dark
                  v-if="Compra.sts != 'A' && Compra.sts != 'C'"
                  @click="addProd()"
                >
                  Agregar Producto
                </v-btn>
                <!-- Snackbar pegado debajo del botón -->
                <v-snackbar
                  v-model="snackDptMissing"
                  absolute
                  :timeout="2200"
                  elevation="2"
                  transition="slide-y-transition"
                  :style="{
                    top: 'calc(100% + 26px)',
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }"
                >
                  Primero selecciona un <strong>Departamento</strong>.
                  <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" @click="snackDptMissing = false"
                      >OK</v-btn
                    >
                  </template>
                </v-snackbar>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-expand-transition>

    <v-expand-transition>
      <v-alert
        v-show="Compra.dpt && Compra.amc && !Compra.adq.length"
        type="info"
        border="left"
        class="mt-2"
        prominent
        outlined
      >
        Agrega un <strong> Producto </strong> para completar la compra
      </v-alert>
    </v-expand-transition>

    <v-expand-transition>
      <v-card
        v-show="Compra.adq && Compra.adq.length"
        class="mt-2"
        elevation="2"
        rounded="xl"
      >
        <v-card-text>
          <div v-if="Compra.adq">
            <h4>Requerimientos || Total:{{ total }}</h4>
            <v-expansion-panels accordion>
              <v-expansion-panel
                v-for="(grupo, grupoIndex) in agrupadosPorProveedor"
                :key="'grupo-' + grupoIndex"
              >
                <v-expansion-panel-header color="#f0f0f0">
                  {{ grupo.proveedor }} - Totales: {{ grupo.total }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <v-card>{{ grupo.items }}</v-card> -->
                  <v-list flat>
                    <v-list-item
                      v-for="(pres, index) in grupo.items"
                      :key="'item-' + index"
                    >
                      <v-list-item-content>
                        <v-row>
                          <v-col md="4" cols="12">
                            <v-autocomplete
                              v-model="pres.prs"
                              :items="presentacionesGlobal"
                              item-text="title"
                              item-value="Id"
                              label="Presentación"
                              outlined
                              dense
                              readonly
                            />
                          </v-col>
                          <v-col md="1" cols="12">
                            <v-text-field
                              outlined
                              dense
                              :disabled="Compra.sts == 'A'"
                              v-model="pres.cnt"
                              label="Cnt."
                            ></v-text-field>
                          </v-col>

                          <v-col md="2" cols="12">
                            <v-text-field
                              outlined
                              dense
                              :disabled="Compra.sts == 'A'"
                              v-model="pres.pcu.C"
                              label="Precio Unitario"
                              :error="sobreCostoByPrs[pres.prs]"
                              :error-messages="
                                sobreCostoByPrs[pres.prs]
                                  ? ['Supera el doble del costo promedio']
                                  : []
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col md="2" cols="12">
                            <v-text-field
                              outlined
                              dense
                              label="Costo prom. actual"
                              :value="
                                costoRefByPrs[pres.prs] != null
                                  ? $pgsHelper.formatNumber(
                                      costoRefByPrs[pres.prs]
                                    )
                                  : '-'
                              "
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col md="1" cols="12">
                            <v-text-field
                              v-model="pres.precioTotal"
                              :label="'Importe'"
                              outlined
                              dense
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="1" class="d-flex align-center">
                            <v-text-field
                              :value="getProductUnidad(pres, pres.cnt)"
                              label="Total"
                              outlined
                              dense
                              readonly
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="1" cols="12" class="">
                            <v-btn
                              @click="deleteInsumo(pres.globalIndex)"
                              v-if="Compra.sts != 'A'"
                              outlined
                              color="red"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <ag-grid-vue
              v-if="false"
              style="height: 300px"
              class="ag-theme-alpine"
              :columnDefs="columnDefs"
              rowSelection="single"
              :rowData="Compra.adq"
              @gridReady="ongridReady($event)"
              @selection-changed="onSelectionChanged($event)"
            >
            </ag-grid-vue>
            <v-alert
              v-if="Compra.adq.length == 0"
              border="bottom"
              colored-border
              type="info"
              elevation="1"
            >
              La Compra esta vacia.
            </v-alert>
          </div>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import Compra from "../../../clases/Inventarios/Compras.js";
import { mapGetters } from "vuex";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
export default {
  name: "ComprasForm",
  components: { AgGridVue },
  props: ["edit", "dataEdit", "presentaciones", "presentacionesAll"],
  data() {
    return {
      notasProds: "",

      monedas: Currency.getCurrencies(),
      origenes: [],
      tipoOrden: "A",
      estatusList: Compra.getStatusList(),
      types: Compra.getTypes(),
      Compra: Compra.getPropertyModel(),
      rules: Compra.getRules(),
      columnDefs: null,
      editableAmc: true,
      prodSelected: null,
      reqToAdd: {
        cfc: null,
        prd: null,
        prs: "",
        nom: "",
        cnt: 0,
        pcu: { C: 0, M: "MXN" },
      },
      toAddForm: 0,
      selection: [],
      OrdenesCompra: [],
      /*presentacion: PresentacionesAYB.getPropertyModel(),
      presentaciones:[],
      rules:PresentacionesAYB.getRules(),*/
      Proveedores: [],
      costos: {},
      snackDptMissing: false,
    };
  },
  methods: {
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    getCostoRef(prod) {
      const idProd = prod.prd;
      const arr = this.costos && this.costos[idProd];
      // si no hay costos
      if (!arr || !arr.length) return null;
      const dpt = this.Compra && this.Compra.dpt;
      // filtramos por depto si viene definido en la compra
      const filtered =
        dpt != null
          ? arr.filter(
              (e) =>
                String(e && e.depto)
                  .trim()
                  .toUpperCase() === String(dpt).trim().toUpperCase()
            )
          : arr;
      // si no hubo match por depto, no hay dato
      if (!filtered.length) return null;
      // sacamos la suma de los costos (mantengo tu lógica original)
      const sum = filtered.reduce(
        (s, i) => s + (Number(i && i.uct && i.uct.C) || 0),
        0
      );
      // regresamos el promedio
      return sum / filtered.length;
    },
    resetForm() {
      this.prodSelected = null;
      this.reqToAdd = {
        prd: null,
        prs: "",
        nom: "",
        cnt: "",
        pcu: { C: 0, M: "MXN" },
      };
    },
    async getOrdenesCompra() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("AMC_OrdenesCompra", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        /* let dateFormat = new firestore.Timestamp(
          data.FechaCreacion.seconds,
          data.FechaCreacion.nanoseconds
        );*/
        let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
        //let origenData = this.getOrigenById(data.amc);
        this.Documentos.push({
          id: data.id,
          //origenId: origenData.id,
          //origenNombre: origenData.Nombre,
          Nombre: "OC - " + fecha.format("YYYY-MM-DD HH:mm"),
          Fecha: fecha.format("YYYY-MM-DD HH:mm"),
          //Departamento: data.Departamentos[0],
          Aplicado: data.sts,
          Status: data.sts == "F" ? "Completado" : "Pendiente",
          ...data,
        });
      });

      this.OrdenesCompra = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    deleteInsumo(index) {
      this.Compra.adq.splice(index, 1);
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();

      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    addProd() {
      if (!this.Compra || !this.Compra.dpt) {
        this.snackDptMissing = true; // mini alerta
        this.$nextTick(() => this.$refs.dptField?.focus?.()); // enfoca el campo
        return;
      }
      if (this.$refs.formProdAdd.validate()) {
        let prod = this.$pgsHelper.getById(
          this.presentaciones,
          "Id",
          this.reqToAdd.prs
        );

        let proveedor = this.Proveedores.find((prv) => prv.id === prod.pvd) || {
          Nombre: "Proveedor no asignado",
        };
        this.reqToAdd.prd = this.prodSelected;
        this.reqToAdd.producto = prod.nom;
        this.reqToAdd.proveedor = proveedor.Nombre; // Nombre del proveedor.
        this.Compra.adq.push(this.$pgsHelper.cloneObj(this.reqToAdd));
        this.$refs.formProdAdd.reset();
        this.toAddForm++;
        this.resetForm();
      }
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    saveOrdenCompra() {
      if (this.$refs.formPresentacion.validate()) {
        this.Compra.adq.forEach((prod) => {
          prod.cnt = Number(prod.cnt);
          prod.pcu.C = Number(prod.pcu.C);
        });
        this.Compra.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
        this.Compra.nts = this.notasProds;
        let datos = this.Compra;
        this.$alert.alertConfirm({
          action: this.edit ? "guardar" : "guardar",
          obj: "la compra",
          route: this.edit
            ? "AMC-Compras-updateCompra"
            : "AMC-Compras-createCompra",
          data: datos,
          onSuccess: () => {
            //this.getPresentacionesByProduct()
            this.$emit("successData");
          },
        });
      }
    },
    aplicarCompra() {
      let datos = { Id: this.Compra.Id };
      this.$alert.alertConfirm({
        action: "enviar a inventario",
        obj: "la compra",
        route: "AMC-Compras-applyCompra",
        data: datos,
        onSuccess: () => {
          //this.getPresentacionesByProduct()
          this.$emit("successData");
        },
      });
    },
    changeOrdenCompra() {
      if (this.Compra.ocm && this.tipoOrden == "O") {
        let ordenCompra = this.$pgsHelper.getById(
          this.OrdenesCompra,
          "id",
          this.Compra.ocm
        );
        this.Compra.amc = ordenCompra?.amc;
        this.Compra.adq = [];
        ordenCompra.req.forEach((req, index) => {
          let presentacion = this.$pgsHelper.getById(
            this.presentaciones,
            "prd",
            req.prd
          );
          this.Compra.adq.push({
            prs: presentacion.Id,
            nom: presentacion.nom,
            prd: req.prd,
            cnt: 1,
            pcu: { C: 0, M: "MXN" },
          });
        });
        this.editableAmc = false;
      } else {
        this.Compra.ocm = null;
        this.editableAmc = true;
      }
    },
    async getProveedores() {
      let proveedorArray = [];
      const database = await this.$store.getters.getFirebaseApp.database;
      const data = await database.queryBuilder("AMC/Provedores", []);
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());
        arrayFactura.forEach((element) => {
          proveedorArray.push({
            id: element[0],
            Nombre: element[1]["nom"],
          });
        });
        this.Proveedores = proveedorArray;
      }
    },
    getProductUnidad(pres, amount) {
      const cantidad = pres?.presentacion?.rdm ?? null;
      const producto = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        pres.presentacion.prd
      );

      const unidad = producto?.Extra?.AYB?.UM || "PZA";

      return cantidad ? `${cantidad * amount} ${unidad}` : unidad;
    },
  },
  computed: {
    costoRefByPrs() {
      const map = {};
      const adq =
        this.Compra && Array.isArray(this.Compra.adq) ? this.Compra.adq : [];
      adq.forEach((item) => {
        // obtenemos la presentación para leer el rdm
        item.presentacion = this.$pgsHelper.getById(
          this.presentaciones,
          "Id",
          item.prs
        );
        const refUnit = this.getCostoRef(item); // costo por 1 medida/unidad
        const rdm = Number(item?.presentacion?.rdm);
        const factor = Number.isFinite(rdm) && rdm > 0 ? rdm : 1;
        // costo de referencia por presentación = costo unitario * rendimiento
        map[item.prs] = refUnit != null ? refUnit * factor : null;
      });
      return map;
    },

    sobreCostoByPrs() {
      const map = {};
      const adq =
        this.Compra && Array.isArray(this.Compra.adq) ? this.Compra.adq : [];
      // usamos el mapa ya ajustado por rendimiento
      const refsPorPresentacion = this.costoRefByPrs;
      adq.forEach((item) => {
        const refPres = refsPorPresentacion[item.prs]; // ref por presentación
        const price = Number(item && item.pcu && item.pcu.C);
        const hasPrice = Number.isFinite(price);
        // solo evaluamos si hay ref válida (>0) y precio válido
        map[item.prs] =
          refPres != null && refPres > 0 && hasPrice
            ? price > refPres * 2
            : null;
      });

      return map;
    },
    agrupadosPorProveedor() {
      if (this.Compra.adq.length > 0) {
        const grupos = this.Compra.adq.reduce((acc, item, index) => {
          const precioTotal = item.pcu.C * item.cnt;
          const unidadPrecio = item.pcu.M;
          const proveedorNombre = item.proveedor;
          item.globalIndex = index;
          item.precioTotal = precioTotal;

          if (!acc[proveedorNombre]) {
            acc[proveedorNombre] = {
              proveedor: proveedorNombre,
              items: [],
              total: {},
            };
          }
          acc[proveedorNombre].items.push(item);

          if (!acc[proveedorNombre].total[unidadPrecio]) {
            acc[proveedorNombre].total[unidadPrecio] = 0;
          }
          acc[proveedorNombre].total[unidadPrecio] += precioTotal;

          return acc;
        }, {});

        return Object.values(grupos).map((grupo) => ({
          ...grupo,
          total: Object.entries(grupo.total)
            .map(
              ([moneda, total]) =>
                `${moneda}: $${this.$pgsHelper.formatNumber(total)}`
            )
            .join(", "),
        }));
      } else {
        return [];
      }
    },

    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    total() {
      let total = 0;
      if (this.Compra.adq) {
        this.Compra.adq.forEach((ins) => {
          total += Number(ins.pcu.C) * ins.cnt;
        });
      }

      return this.$pgsHelper.formatNumber(total);
    },
    presentacionesGlobal() {
      let presentacionesSource = this.presentaciones;
      if (this.Compra.sts == "A") {
        presentacionesSource = this.presentacionesAll;
      }

      let presentaciones = [];
      if (presentacionesSource) {
        presentacionesSource.forEach((pres) => {
          let proveedor =
            this.Proveedores.find((prv) => prv.id === pres.pvd) || {};
          let producto = this.$pgsHelper.getById(
            this.global_prod,
            "id",
            pres.prd
          );

          if (producto?.Nombre) {
            pres.title =
              (producto.Nombre ?? "") +
              " - " +
              (pres.nom ?? "") +
              " - " +
              (pres.rdm ?? "") +
              " " +
              (producto.Extra?.AYB?.UM ?? "") +
              " - " +
              (proveedor.Nombre ?? "");

            if (pres.title && !pres.title.includes("undefined")) {
              presentaciones.push(pres);
            }
          }
        });
      }

      return presentaciones;
    },

    presentacionesBySelectedProd() {
      let presentaciones = [];
      this.presentaciones.forEach((pres) => {
        if (pres.prd == this.prodSelected) {
          let proveedor =
            this.Proveedores.find((prv) => prv.id === pres.pvd) || "";
          let producto = this.$pgsHelper.getById(
            this.global_prod,
            "id",
            pres.prd
          );
          pres.title =
            pres.nom +
            " - " +
            pres.rdm +
            " " +
            producto.Extra?.AYB?.UM +
            "" +
            " - " +
            proveedor.Nombre;
          presentaciones.push(pres);
        }
      });
      return presentaciones;
    },
    unidadMedida() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.reqToAdd.prd
      );

      if (prod) {
        return prod?.Extra?.AYB?.UM || "PZ";
      }
      return "";
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "Producto") &&
          !element.Dlat
        ) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {},
  beforeMount: function () {},
  async mounted() {
    this.columnDefs = [
      {
        field: "nom",
        editable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: { values: this.presentaciones },
      },
      { field: "cnt", editable: true },
    ];
    this.getOrigenes();
    this.getOrdenesCompra();
    if (this.edit) {
      this.Compra = new Compra(this.dataEdit);
      this.notasProds = this.dataEdit.nts ? this.dataEdit.nts : "";
      if (this.Compra.ocm) {
        this.tipoOrden = "O";
      }
    } else {
      this.Compra = new Compra();
    }
    await this.getProveedores();
    await this.getCostos();
  },
};
</script>
